import { render, staticRenderFns } from "./Thermal.vue?vue&type=template&id=621791c5&scoped=true&"
import script from "./Thermal.vue?vue&type=script&lang=js&"
export * from "./Thermal.vue?vue&type=script&lang=js&"
import style0 from "./Thermal.vue?vue&type=style&index=0&id=621791c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621791c5",
  null
  
)

export default component.exports